import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import {LayoutContent, LayoutLeft, LayoutRight} from "../Components/Shared/Layout/LayoutContent";
import withLanguage from "../HOC/withLanguage";
import Titles from "../Components/Shared/Layout/Titles";
import React, {useEffect, useState} from "react";
import Carousel from "react-multi-carousel";
import {useSelector} from "react-redux";


const NewProfessional = ({language})=>{
    const lang = useSelector((state) => state.language.currentLanguage);

    const [textItems, setTextItems] = useState([]);
    const [imgItems, setImgItems] = useState([]);

    const [loadingText, setLoadingText] = useState(true);
    const [loadingImgs, setLoadingImgs] = useState(true);
    const [errText, setErrText] = useState(null);
    const [errImgs, setErrImgs] = useState(null);

    const [openIndex, setOpenIndex] = useState(null); // modal for read more
    const truncateAt = 120;

    useEffect(() => {
        const ac = new AbortController();
        setLoadingImgs(true);
        setErrImgs(null);

        const url = `/api/student_dual_images/life_professional_dual_images`;
        fetch(url, { signal: ac.signal })
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data) => {
                const list = Array.isArray(data?.records) ? data.records : [];
                setImgItems(list);
            })
            .catch((e) => {
                if (e.name !== "AbortError") setErrImgs(e.message || "Failed to load");
            })
            .finally(() => setLoadingImgs(false));

        return () => ac.abort();
    }, []);

    const truncate = (str, max = truncateAt) =>
        typeof str === "string" && str.length > max ? str.slice(0, max) + "..." : str ?? "";

    // carousel config: 3 desktop / 2 tablet / 1 mobile (as requested)
    const imgResponsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 640 }, items: 2 },
        mobile: { breakpoint: { max: 640, min: 0 }, items: 1 },
    };

    console.log(imgItems)

    return (
        <>
            <Banner img='/NewProfessional/banner.jpg' title={language.banner}/>

            <IntroBlock>{language.introText}</IntroBlock>

            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <p className="text-lg py-3 text-justify">{language.p1}</p>
            </div>

            {loadingImgs && <div className="p-6 text-center">Loading images…</div>}
            {errImgs && <div className="p-6 text-center text-red-600">Error: {errImgs}</div>}

            {!loadingImgs && !errImgs && imgItems.length > 0 && (
                <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                    <Carousel responsive={imgResponsive}>
                        {imgItems.map((img, idx) => {
                            const src = `data:image/jpeg;base64,${img?.image || ""}`;
                            return (
                                <div key={img.id ?? idx} className="px-2 pb-5">
                                    <div className="rounded-xl shadow-md bg-white overflow-hidden">
                                        {/* Use a fixed aspect box for neatness */}
                                        <div className="w-full aspect-[4/3]">
                                            <img
                                                src={src}
                                                alt={img?.title || `Image ${idx + 1}`}
                                                className="w-full h-full object-cover"
                                                loading="lazy"
                                            />
                                        </div>
                                        {img?.title && (
                                            <div className="p-3">
                                                <p className="text-center text-sm font-medium">{img.title}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>
                </div>
            )}

        </>
    )
}

export default withLanguage(NewProfessional,"NewProfessional")